import { Close } from '@mui/icons-material';
import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    Radio,
    RadioGroup,
    Select,
    Tab,
    Tabs
} from '@mui/material';
import * as Sentry from '@sentry/react';
import { Col, Row, Tooltip } from "antd";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import QnALoader from "components/VocabQnAModal/QnALoader";
import { flatMap, map } from "lodash";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { usePageGrammarContent, usePageVocabContent } from "store/page_translations/selectors";
import { useUserProfileConfig } from "store/users/selectors";
import styled from "styled-components";
import { BOOK_REFRENCES, question_type_generate_more } from "utils/config/reference";
import { handleStreamResponse } from 'utils/methods/QuestionCreateStreamHandle';
import { levelsData } from 'components/StoryWithAi/constants';
import SentryWrap from 'components/Sentry';
import { useCurrentUser } from 'store/users/selectors'
import { resource_types } from 'store/extraResource/constants';

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 250px;
  max-height: 80vh;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color:${p=>p.bgColor?p.bgColor: "#fff"};
  padding: 20px;
  overflow: auto;
  @media only screen and (max-width: 600px) {
    min-width: 90% !important;
  }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;

const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
  color:${p=>p.color?p.color:"black"};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: 10px;
  text-align: center;
`;
const RadioColumn = styled(Col)`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

const isSameSelectableContent = (prevList = [], nextList = []) => {
    if (prevList === nextList) return true;
    if (!Array.isArray(prevList) || !Array.isArray(nextList)) return false;
    if (prevList.length !== nextList.length) return false;
    return prevList.every((item, index) => {
        const nextItem = nextList[index];
        return String(item?.pageId) === String(nextItem?.pageId)
            && String(item?.numberMasked) === String(nextItem?.numberMasked)
            && String(item?.page_dynamic_id) === String(nextItem?.page_dynamic_id);
    });
};

const AssignmentAiSection = ({ assignmentAiModal, setassignmentAiModal, data , page , chapter , pageSrc , content, fromResource, from, generateVocabActivity, setGenerateVocabActivity = () => { }, uniqueKeyAssignmentAi, onAddQuestionsToAssignment = () => { }, BALCON_PAGES = [] , modalZIndex = null , pageRenage = {} }) => {
    const showAlert = useAlert();
    const currentUser = useCurrentUser();
    const isAdmin = currentUser?.role === 'admin';
    const [fromPageId, setFromPageId] = useState(page);
    const [toPageId, setToPageId] = useState(null);
    const [hasError, setHasError] = useState(false);
    const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
    const [ai_questions,setAiQuestions] = useState([]);
    const [loader,setLoader] = useState(false);
    const [loaderMore,setLoaderMore] = useState(false);
    const [selectableContent, setSelectableContent] = useState([]);
    const [selectedVocabContent, setSelectedVocab] = useState([]);
    const [title,setTitle] = useState('');
    const { book_grammar_content } = usePageGrammarContent()
    const { book_vocb_content } = usePageVocabContent()
    const has_page_content = useMemo(() => book_grammar_content?.find((page_content) => page_content.chapter == chapter && page_content.page == page), [book_grammar_content, page, chapter])
    const grammer_content = useMemo(()=>has_page_content?.content||[],[has_page_content, book_grammar_content])
    const book_vocab_content = useMemo(() => book_vocb_content?.filter((page_content) => page_content.chapter == chapter)||[], [book_vocb_content, chapter])
    const has_page_vocab_content = useMemo(() => {
        if(!book_vocab_content?.length) return null;
        return book_vocab_content.find((page_content) => {
            if(page_content.page == page) return true;
            return page_content.content?.some(item => {
                const from = parseInt(item.from_page), to = item.to_page ? parseInt(item.to_page) : null;
                const curr = parseInt(page);
                return to ? curr >= from && curr <= to : curr === from;
            });
        });
    }, [book_vocab_content, page, chapter])
    const vocab_content = useMemo(()=>has_page_vocab_content?.content || [],[has_page_vocab_content])
    const show_vocab_generation = has_page_vocab_content && (generateVocabActivity || !has_page_content)
    const showGrammarTab = Boolean(has_page_content);
    const showVocabTab = vocab_content.length > 0;
    const showDefaultTab = !showGrammarTab && !showVocabTab;

    const [generatedCount,SetGenerateCount] = useState(0)
    const questionRequestIdRef = useRef(0);
     const [selectedTypes, setSelectedTypes] = useState(
        question_type_generate_more.map(option => option.value)
    );
    const [proficiencyLevel,setProficiencyLevel] = useState("");
    const [selectedContent, setSelectedContent] = useState({
        title: '',
        prompt: ''
    })
    const { isAiPermissionEnabled } = useUserProfileConfig();
    const [language,setLanguage] = useState("spanish");
    const [selectedActivityTab, setSelectedActivityTab] = useState("grammar");
    const isSupportBook = useMemo(()=>{
      return from === resource_types.balcon || from === resource_types.conectándome || from === resource_types.comunidad || from === resource_types.informate || from === resource_types.story || from === resource_types.AP;
    },[from])
    const fromPageIndex = useMemo(() => {
        const selectedIndex = selectableContent.findIndex((item) => String(item?.pageId) === String(fromPageId));
        return selectedIndex >= 0 ? selectedIndex : 0;
    }, [selectableContent, fromPageId]);
    const toPageOptions = useMemo(() => {
        if (!Array.isArray(selectableContent) || selectableContent.length === 0) return [];
        return selectableContent.slice(fromPageIndex, fromPageIndex + 10);
    }, [selectableContent, fromPageIndex]);
    const getPageDisplayValue = useCallback((bk) => {
        if (!bk) return '';
        if (bk.page_dynamic_id) return bk.page_dynamic_id;
        if (bk.numberMasked) return bk.numberMasked;
        return bk.pageId;
    }, []);

    
    const getCurrentUnit = useMemo(() => {
        if (isSupportBook && page && BALCON_PAGES?.length > 0) {
            const currentPageNum = parseInt(page, 10);
            return BALCON_PAGES.find(p => {
                const startNum = parseInt(p.start, 10);
                const finishNum = parseInt(p.finish, 10);
                return startNum <= currentPageNum && finishNum >= currentPageNum;
            });
        }
        return null;
    }, [from, BALCON_PAGES, page,isSupportBook]);
    
    useEffect(() => {
        setSelectedContent({
            title: '',
            prompt: ''
        })
    }, [grammer_content])
    useEffect(() => {
      if (Object.keys(pageRenage)?.length > 0 && assignmentAiModal && BALCON_PAGES?.length > 0) {
        const startPage = parseInt(pageRenage.start, 10);
        const finishPage = parseInt(pageRenage.finish, 10);
        setSelectableContent(BALCON_PAGES.map((p,i)=>({...p,page_dynamic_id:i+1})));
        setFromPageId(startPage);
        setToPageId(finishPage);  
      }
        else if (page && ((data && data.content)||Array.isArray(content)) && chapter&&assignmentAiModal) {
            const contents = Array.isArray(content)?content:data.content || [];
            let filteredContents = contents;
            
            if (getCurrentUnit && isSupportBook) {
                const unitStart = parseInt(getCurrentUnit.start, 10);
                const unitFinish = parseInt(getCurrentUnit.finish, 10);
                filteredContents = contents.filter((k) => {
                    const pageId = parseInt(k.pageId, 10);
                    return pageId >= unitStart && pageId <= unitFinish;
                });
            }
            
            const nextSelectableContent = filteredContents.map((k,i)=>(isSupportBook ? {...k,page_dynamic_id:i+1} : {...k}));
            setSelectableContent((prev) => isSameSelectableContent(prev, nextSelectableContent) ? prev : nextSelectableContent)
            
            setToPageId((prev) => {
                if (prev === null || prev === '') return prev;
                const hasPrevSelection = nextSelectableContent.some((item) => String(item.pageId) === String(prev));
                return hasPrevSelection ? prev : null;
            });
            const selectedIndex = filteredContents.findIndex((bk) => bk.pageId == page);
            if(selectedIndex>=0){
                const alreadySelectedPage = nextSelectableContent.some((item) => String(item?.pageId) === String(fromPageId));
                const defaultPageId = alreadySelectedPage ? fromPageId : filteredContents[selectedIndex]?.pageId;
                if (defaultPageId) {
                    setFromPageId(defaultPageId);
                }
            }
      
        }

    }, [data, page, chapter, assignmentAiModal, content, getCurrentUnit, from, BALCON_PAGES,isSupportBook])
    useEffect(()=>{
        if(assignmentAiModal){
            const currentPageItem = selectableContent.find((item) => String(item?.pageId) === String(page));
            setFromPageId(currentPageItem?.pageId || page || '');
            setToPageId(null);
            setHasError(false)
        }
    },[assignmentAiModal, selectableContent, page])
    useEffect(() => {
        if (!toPageId) return;
        const isValidToPage = toPageOptions.some((item) => String(item?.pageId) === String(toPageId));
        if (!isValidToPage) {
            setToPageId(null);
        }
    }, [toPageId, toPageOptions]);

    useEffect(() => {
        if (!isQuestionModalOpen) {
            questionRequestIdRef.current += 1;
            setAiQuestions([]);
            setLoader(false);
            setLoaderMore(false);
            SetGenerateCount(0);
        }
    }, [isQuestionModalOpen])

    useEffect(() => {
        if (showGrammarTab && showVocabTab) {
            setSelectedActivityTab((prev) => prev === "vocab" ? "vocab" : "grammar");
            return;
        }
        if (showGrammarTab) {
            setSelectedActivityTab("grammar");
            return;
        }
        if (showVocabTab) {
            setSelectedActivityTab("vocab");
            return;
        }
        if (showDefaultTab) {
            setSelectedActivityTab("bookPage");
            return;
        }
        setSelectedActivityTab("");
    }, [showGrammarTab, showVocabTab, showDefaultTab]);
    const handleFromPageChange = (event) => {
        const selectedPageId = event.target.value;
        const selectedIndex = selectableContent.findIndex(
            (bk) => String(bk.pageId) === String(selectedPageId)
        );
        if (selectableContent[selectedIndex]) {
            setFromPageId(selectableContent[selectedIndex].pageId);
        }
        setToPageId(null);
    };

    const handleToPageChange = (event) => {

      const selectedPageId = event.target.value;
        const selectedIndex = selectableContent.findIndex(
            (bk) => String(bk.pageId) === String(selectedPageId)
        );
        if (selectedIndex >= 0) {
            const selectedToPageId = selectableContent[selectedIndex].pageId;
            if (parseInt(selectedToPageId) - parseInt(fromPageId) > 9) {
                showAlert("Maximum 10 pages can be select.","error")
            } else {
                setToPageId(selectedToPageId)
            }
        }

    };

    // Validation function
    const validateFields = () => {
      if (fromResource === 'resource') {
        // In resource flow we don't require from/to page, only other fields are validated via `disable`
        setHasError(false);
        return true;
      }
      if (!fromPageId  || !toPageId) {
        setHasError(true);
        showAlert("Both the starting page and ending page are required!","error")
        return false;
      } else {
        const diff = parseInt(toPageId) - parseInt(fromPageId);
        if (Number.isFinite(diff) && diff > 9) {
          showAlert(`A maximum of 10 pages can be used to create an activity!`,"error")
          return false;
        }
        setHasError(false);
        return true;
      }
    };

    // Handle form submission
    const handleGenerate = async (is_more,languageKey = null) => {
        if (!isAiPermissionEnabled) {
            showAlert('Please enable AI permission to generate questions.', 'error');
            return;
        }
        const isResourceFlow = fromResource === 'resource';
        const canGenerate = isResourceFlow || has_page_content || show_vocab_generation || validateFields();
        if ( !canGenerate) {
          return;
        }

            setIsQuestionModalOpen(true);
            setLoader(!is_more)
            const requestId = questionRequestIdRef.current + 1;
            questionRequestIdRef.current = requestId;
            if (!is_more) {
                setAiQuestions([])
            }
            setLoaderMore(true)
            try {
                const data = JSON.stringify({
                    bookId: chapter,
                    from_page: isResourceFlow ? "" : ((generateVocabActivity || !has_page_content) && selectedVocabContent.length > 0 ? selectedVocabContent[0].from_page : fromPageId),
                    to_page: isResourceFlow ? "" : ((generateVocabActivity || !has_page_content) && selectedVocabContent.length > 0 ? String(selectedVocabContent[0].to_page) : String(toPageId)),
                    question_type: selectedTypes || [],
                    grammar_prompt: (generateVocabActivity || !has_page_content) ? '' : selectedContent?.prompt,
                    vocab_config: (generateVocabActivity || !has_page_content) ? selectedVocabContent : null,
                    proficiencyLevel: proficiencyLevel,
                    question_language: (languageKey ? languageKey : language)?.toLowerCase(),
                    resource: isResourceFlow,
                    answerLang: 'spanish'
                })
                await handleStreamResponse({
                    path: "ai/generate/generate-questions-stream",
                    body: data,
                    onTitle: (title) => {
                        if (questionRequestIdRef.current !== requestId) return;
                        setTitle(title)
                        SetGenerateCount(0)
                    },
                    onQuestion: (question) => {
                        if (questionRequestIdRef.current !== requestId) return;
                        setAiQuestions(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
                        SetGenerateCount(prev => prev + 1)
                        setLoader(false);
                        setLoaderMore(false);
                    },
                    onDone: () => {
                        if (questionRequestIdRef.current !== requestId) return;
                        setLoaderMore(false);
                        setLoader(false);
                        SetGenerateCount(0)
                        setLanguage('');
                    },
                    onError: () => {
                        if (questionRequestIdRef.current !== requestId) return;
                        setLoaderMore(false);
                        setLoader(false);
                        SetGenerateCount(0)
                        setLanguage('');
                    }
                })
            } catch (error) {
                showAlert(error?.message || 'something went wrong please try with another page!', 'error')
                Sentry.captureException(`324 Error in AssignmentAiSection: ${error}`);
                setassignmentAiModal(true);
                setIsQuestionModalOpen(false);
            } finally {
                setLoader(false)
                setLoaderMore(false)
            }
    };
    const grammerContent = () => {
        return (<ModalConfigArea>
            <LinkArea>
                <Row gutter={[24, 24]} style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}>
                    <RadioGroup
                        style={{ display: "flex", flexDirection: "column", width: "100%" }}
                        aria-label="options"
                        value={selectedContent.title}
                        onChange={(e) => {
                            const item = grammer_content?.find(k => k.title === e.target.value);
                            if (item) {
                                setSelectedContent(item);
                            }
                        }}
                    >
                        {Array.isArray(grammer_content) && grammer_content.length > 0 &&
                            grammer_content.map((item, index) => (
                                <Row key={`${item.title}-${index}`} style={{ width: "100%", cursor: "pointer", marginBottom: 10 }}>
                                    <RadioColumn span={2}>
                                        <FormControlLabel
                                            value={item.title}
                                            control={<Radio style={isAdmin ? { color: "#fff" } : { color: "#000" }} />}
                                        />
                                    </RadioColumn>
                                    <RadioColumn span={22} style={{ justifyContent: "flex-start" }}>
                                        <div
                                            onClick={() => setSelectedContent(item)}
                                            style={{ cursor: "pointer", width: "100%" }}
                                        >
                                            <TitleText color={isAdmin ? 'white' : 'black'} style={{ fontSize: 15 }}>
                                                {item.title}
                                            </TitleText>
                                        </div>
                                    </RadioColumn>
                                </Row>
                            ))
                        }
                    </RadioGroup>

                    <Button
                        fullWidth
                        color="primary"
                        disabled={!selectedContent.title}
                        variant="contained"
                        onClick={() => selectedContent.title ? handleGenerate() : null}
                    >
                        Generate
                    </Button>
                </Row>
            </LinkArea>
        </ModalConfigArea>)
    }
    const vocabContent = () => {
        const handleCheckboxChange = (item, checked) => {
            setSelectedVocab(prev => {
                if (checked) {
                    return prev.some(selected => selected.title === item.title) 
                        ? prev 
                        : [...prev, item];
                } else {
                    return prev.filter(selected => selected.title !== item.title);
                }
            });
        };

        return (
            <ModalConfigArea>
                <LinkArea>
                    <Row gutter={[24, 24]} style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}>
                        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            {Array.isArray(vocab_content) &&
                                vocab_content.map(item => (
                                    <Row key={item.title} style={{ width: "100%", cursor: "pointer" }}>
                                        <RadioColumn span={2}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        style={isAdmin ? { color: "#fff" } : { color: "#000" }}
                                                        checked={selectedVocabContent.some(selected => selected.title === item.title)}
                                                        onChange={(e) => handleCheckboxChange(item, e.target.checked)}
                                                    />
                                                }
                                                value={item.title}
                                            />
                                        </RadioColumn>
                                        <RadioColumn span={22} style={{ justifyContent: "flex-start" }}>
                                            <div
                                                onClick={() => {
                                                    const isChecked = selectedVocabContent.some(selected => selected.title === item.title);
                                                    handleCheckboxChange(item, !isChecked);
                                                }}
                                                style={{ cursor: "pointer", width: "100%" }}
                                            >
                                                <TitleText color={isAdmin ? 'white' : 'black'} style={{ fontSize: 15 }}>
                                                    {item.title}
                                                </TitleText>
                                            </div>
                                        </RadioColumn>
                                    </Row>
                                ))
                            }
                        </div>
                        <Button
                            fullWidth
                            color="primary"
                            disabled={selectedVocabContent.length === 0}
                            variant="contained"
                            onClick={() => selectedVocabContent.length > 0 ? handleGenerate() : null}
                        >
                            Generate
                        </Button>
                    </Row>
                </LinkArea>
            </ModalConfigArea>
        );
    }

    const defaultContent = () => {
        return (
              <ModalConfigArea>
                <LinkArea>
                {fromResource !== 'resource' && (
                  <Row
                    gutter={[24, 24]}
                    style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
                    className="floatingLabelBG"
                  >
                    <FormControl variant="outlined" style={{ minWidth: 200 }}>
                      <InputLabel id="fromPageLabel">From Page</InputLabel>
                      <Select
                        labelId="fromPageLabel"
                        id="fromPage"
                        value={fromPageId || ''}
                        onChange={handleFromPageChange}
                        label="From Page"
                      >
                        {map(selectableContent, (bk, index) => {
                          const displayValue = getPageDisplayValue(bk);
                          return (
                            <MenuItem key={index} value={bk.pageId}>
                              {displayValue}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    </Row>
                  )}

                  {fromPageId && (
                    <Row
                      gutter={[24, 24]}
                      style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
                      className="floatingLabelBG"
                    >
                      <FormControl variant="outlined" style={{ minWidth: 200 }}>
                        <InputLabel id="toPageLabel">To Page</InputLabel>
                        <Select
                          labelId="toPageLabel"
                          id="toPage"
                          value={toPageId || ''}
                          onChange={handleToPageChange}
                          label="To Page"
                        >
                          {map(toPageOptions, (bk, index) => {
                            const displayValue = getPageDisplayValue(bk);
                            return (
                              <MenuItem key={index} value={bk.pageId}>
                                {displayValue}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Row>
                  )}

                  <Row
                    gutter={[24, 24]}
                    style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
                    className="floatingLabelBG"
                  >
                    <FormControl variant="outlined" style={{ minWidth: 200 }}>
                      <InputLabel id="fromPageLabel">
                        Proficiency Level
                      </InputLabel>
                      <Select
                        labelId="fromPageLabel"
                        id="fromPage"
                        value={proficiencyLevel}
                        onChange={(e) => setProficiencyLevel(e.target.value)}
                        label="From Page"
                      >
                        {levelsData.map((item, index) => (
                          <MenuItem key={index} value={item?.label}>
                            <Tooltip zIndex={9999999} color={'#3d5f8f'} title={item?.label}>
                              {item?.label?.length > 40
                                ? `${item?.label?.substring(0, 40)}...`
                                : item?.label}
                            </Tooltip>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Row>

                  <Row
                    gutter={[24, 24]}
                    style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
                    className="floatingLabelBG"
                  >
                    <FormControl variant="outlined" style={{ minWidth: 200 }}>
                      <InputLabel id="fromPageLabel">
                        Select Language
                      </InputLabel>
                      <Select
                        labelId="fromPageLabel"
                        id="fromPage"
                        value={language}
                        onChange={(e) => setLanguage(e.target.value)}
                        label="Select Language"
                      >
                        {languageMenuItems.map((item, index) => (
                          <MenuItem key={index} value={item?.key}>
                            <Tooltip zIndex={9999999} color={'#3d5f8f'} title={item?.label}>
                              {item?.label?.length > 40
                                ? `${item?.label?.substring(0, 40)}...`
                                : item?.label}
                            </Tooltip>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Row>

                  <Row gutter={[24, 24]} style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}>
                    <Button
                      fullWidth
                      color="primary"
                      disabled={disable}
                      variant="contained"
                      onClick={() => (!disable ? handleGenerate() : null)}
                    >
                      Generate
                    </Button>
                  </Row>

                  {hasError && <ErrorMessage>Please select all the required fields.</ErrorMessage>}
                </LinkArea>
              </ModalConfigArea>
        )
    }
    
    const disable = useMemo(
      () =>
        fromResource === 'resource'
          ? !Boolean(proficiencyLevel) || !Boolean(language)
          : !Boolean(fromPageId) || !Boolean(toPageId) || !Boolean(proficiencyLevel) || !Boolean(language),
      [fromPageId, toPageId, proficiencyLevel, language, fromResource]
    );
    // const generated_question = useMemo(() =>ai_questions.map(k=>({ ...k , id : Math.random()*1000000000})),[ai_questions])

    const handleClose = () => {
      try{
        questionRequestIdRef.current += 1;
        setassignmentAiModal(false);
        setIsQuestionModalOpen(false);
        setAiQuestions([]);
        setLoader(false);
        setLoaderMore(false);
        setGenerateVocabActivity(false);
        setProficiencyLevel('');
        setLanguage('');
        setSelectedVocab([]);
      }catch(error){
        Sentry.captureException(error);
      }
    };

    const languageMenuItems = [
      {
          key: 'spanish',
          label: 'Spanish'
      },
      {
          key: 'english',
          label: 'English'
      }
  ];
  const book_label = useMemo(() => {
    if (from == "podcast") {
      return "1Way Resource"
    }
    if (isSupportBook) {
      if (BOOK_REFRENCES[chapter]) {
        return BOOK_REFRENCES[chapter]
      }
      return "Book Page"
    }
    return "Book Page"
  }, [from, chapter])
    return (<SentryWrap>
      <div>
        {/* AssignmentAiQuestionSection Modal */}
        {isQuestionModalOpen ? (
          <QnALoader
            assignmentAiModal={isQuestionModalOpen}
            setAssignmentAiModal={setIsQuestionModalOpen}
            handleGenerateMoreQnA={(topic,language) => handleGenerate(true,language)}
            generateQnALoader={loader}
            questionGenerator={ai_questions}
            page={page}
            assignmentTitle={title}
            chapter={chapter}
            pageSrc={pageSrc}
            loading={loaderMore}
            from={'ai_image'}
            selectedTypes={selectedTypes}
            setSelectedTypes={setSelectedTypes}
            generatedCount={generatedCount}
            setQuestionGenerator={setAiQuestions}
            uniqueKeyAssignmentAi={uniqueKeyAssignmentAi}
            onAddQuestionsToAssignment={onAddQuestionsToAssignment}
            modalZIndex={modalZIndex}
            onClose={handleClose}
            dismissAssignmentAiParentOnSave
          />
        ) : null}
        {/* AssignmentAiSection Modal */}
        <Modal
          open={assignmentAiModal&&!isQuestionModalOpen}
          onClose={handleClose}
          style={{ height: '100%', width: '100%' }}
          sx={modalZIndex != null ? { zIndex: modalZIndex } : undefined}
        >
          <ModalContent bgColor={has_page_content || show_vocab_generation ? isAdmin ? '#0e2639' : '#fff' : null}>
            <Row style={{ justifyContent: 'space-between' }}>
              <TitleText color={has_page_content || show_vocab_generation ? isAdmin ? 'white' : 'black' : 'black'}>
                {'Assignment with AI'}
              </TitleText>
              <IconButton
                onClick={handleClose}
                style={{ padding: 0 }}
              >
                <Close color="secondary" />
              </IconButton>
            </Row>
            
                <Tabs
                  value={selectedActivityTab}
                  onChange={(_, value) => setSelectedActivityTab(value)}
                  textColor="inherit"
                  indicatorColor="secondary"
                  variant="fullWidth"
                  style={{ marginTop: 12 }}
                >
                  {<Tab label={book_label} value="bookPage" />}
                  {showGrammarTab ? <Tab label="Grammar AI Activity" value="grammar" /> : null}
                  {showVocabTab ? <Tab label="Vocab Ai Activity" value="vocab" /> : null}
                </Tabs>
                {selectedActivityTab === "bookPage" && defaultContent()}
                {selectedActivityTab === "grammar" && showGrammarTab ? grammerContent() : null}
                {selectedActivityTab === "vocab" && showVocabTab ? vocabContent() : null}

          </ModalContent>
        </Modal>
      </div>
      </SentryWrap>);
};

export default AssignmentAiSection;

